module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scenario_common_params"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.title')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('scenarios.scenarioName')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": function($event) {
        return _vm.scenarioNameChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hideArrowsVar),
      expression: "hideArrowsVar"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hideArrowsVar) ? _vm._i(_vm.hideArrowsVar, null) > -1 : (_vm.hideArrowsVar)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.hideArrowsVar,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hideArrowsVar = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hideArrowsVar = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hideArrowsVar = $$c
        }
      }, function($event) {
        return _vm.hideArrowsChange()
      }]
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('scenarios.konstruktor.commonParams.hideArrows')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "commonParameters"
  }, [_c('div', {
    staticClass: "field is-horizontal locale"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.language')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.googleLanguages) ? _c('div', {
    staticClass: "select langSelect"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lang),
      expression: "lang"
    }],
    staticClass: "form-control lang scenarioLang",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.localeChange()
      }]
    }
  }, _vm._l((_vm.googleLanguages), function(language) {
    return _c('option', {
      domProps: {
        "value": language.value
      }
    }, [_vm._v("\n                  " + _vm._s(language.label) + "\n                ")])
  }), 0)]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locale),
      expression: "locale"
    }],
    staticClass: "input scenarioLang",
    attrs: {
      "type": "text",
      "placeholder": "Locale"
    },
    domProps: {
      "value": (_vm.locale)
    },
    on: {
      "change": function($event) {
        return _vm.localeChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.locale = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal locale"
  }, [_c('div', {
    staticClass: "field-label is-normal"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.recognition.recognitionDriver')))])]), _vm._v(" "), _c('div', {
    staticClass: "field-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.driver),
      expression: "driver"
    }],
    staticClass: "form-control vendor",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.driver = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.recognitionDriverChange()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yandex"
    }
  }, [_vm._v("Yandex")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffe66da0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/ScenarioCommonParams.vue
// module id = 547
// module chunks = 42